/*!
 * Copyright (C) Design:Funedikly. All rights reserved.
 */

export const siteData = {
  skills: ['UX Design', 'UX Development', 'Design Engineering', 'Mentorship'],
  tags: ['HTML5', 'CSS3', 'JavaScript', 'TypeScript', 'React.js', 'Node.js', 'Testing', 'Git', 'Project Management', 'SQL', 'NoSQL', 'MongoDB', 'Rest API', 'PHP', 'Figma Plugins'],
  projects: [
    {
      co: 'Microsoft',
      pj: 'Digital Storefront'
    },
    {
      co: 'Verizon',
      pj: 'Design System'
    },
    {
      co: 'Microsoft',
      pj: 'Online Storefronts'
    },
    {
      co: 'Stevens Advertising ',
      pj: 'Ferris Coffee online Store'
    },
    {
      co: 'Microsoft',
      pj: 'Power Platform'
    },
    {
      co: 'Waterfall Productions',
      pj: 'Steelcase University Online Learning Center'
    },
    {
      co: 'Microsoft',
      pj: 'Red Tiger'
    },
    {
      co: 'General Motors',
      pj: 'C7 Corvet Cluster UX and Design'
    }
  ]
};
